import NoInternetConnectionPage from './NoInternetConnectionPage';
export default {
  NoInternetConnectionPage,
};
